// TODO: think about how we could consolidate this and the common/js markets config
export const euroMarkets = [
  'de-at',
  'de-de',
  'ee-ee',
  'en-ie',
  'es-es',
  'fi-fi',
  'fr-be',
  'fr-fr',
  'gr-gr',
  'hr-hr',
  'it-it',
  'lt-lt',
  'lv-lv',
  'nl-be',
  'nl-nl',
  'pt-pt',
  'sk-sk',
];

/**
 * Returns the currency symbol when available in the Intl.
 * E.g. for 'LAK' it Intl returns 'LAK', so this function
 * will return null for that currency.
 *
 * TODO: use this and cover with tests.
 *
 * @param {string} currencyCode e.g. 'EUR'
 */
// export const getCurrencySymbol = (currencyCode, locale) => {
//   const options = { style: 'currency', currency: currencyCode };
//   const numberFormat = new Intl.NumberFormat(locale, options);

//   const formats = numberFormat
//     .formatToParts(0)
//     .filter((p) => p.type === 'currency')
//     .map((p) => p.value);

//   if (formats?.[0] !== currencyCode) {
//     return formats[0];
//   }

//   return null;
// };

/**
 * Rounds a value to 0.001.
 * roundToMillis(1)      = 1
 * roundToMillis(1.1)    = 1.1
 * roundToMillis(1.11)   = 1.11
 * roundToMillis(1.111)  = 1.111
 * roundToMillis(1.1111) = 1.111
 *
 * @param {Number} value A numeric value to round
 * @returns
 */
export const roundToMillis = (value) => (
  Number.isFinite(value) ?
    Math.round(1000 * value) / 1000 :
    0
);
